var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgCurrentPosition = function SvgCurrentPosition(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 15
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.15 15h-1.3V7.5h1.3V15zM9.1 0c1.075 0 1.95.918 1.95 2.045v4.773h-1.3V2.045c0-.376-.292-.681-.65-.681H3.9c-.358 0-.65.305-.65.681v2.046h2.006L2.629 6.818 0 4.091h1.95V2.045C1.95.918 2.825 0 3.9 0h5.2zM3.25 12.273v-2.046H1.3v2.046h1.95zm1.3 1.363H0V8.864h4.55v4.772zm7.15-1.363v-2.046H9.75v2.046h1.95zm1.3 1.363H8.45V8.864H13v4.772z"
  })));
};

export default SvgCurrentPosition;